import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragResizeDirective } from './drag-resize.directive';
import { VisibleDirective } from './visible.directive';
import { RememberScrollPositionDirective } from './rememberScrollPosition.directive';
import { FileDragDropDirective } from './file-drag-drop.directive';
import { ScrollToBottomDirective } from './scroll-to-bottom.directive';
import { AutoFocusDirective } from './auto-focus.directive';
import { TestIdDirective } from './test-id.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    DragResizeDirective,
    VisibleDirective,
    RememberScrollPositionDirective,
    FileDragDropDirective,
    ScrollToBottomDirective,
    AutoFocusDirective,
    TestIdDirective,
  ],
  exports: [
    DragResizeDirective,
    VisibleDirective,
    RememberScrollPositionDirective,
    FileDragDropDirective,
    ScrollToBottomDirective,
    AutoFocusDirective,
    TestIdDirective,
  ],
})
export class SharedDirectivesModule {}
